import Header from '../../components/common/header/index.vue'
import Bottom from '../../components/common/bottom/index.vue'
import titleCom from '../../components/common/title.vue'
import axios from 'axios'
export default {
  name: 'culturalDetail',
  components: { Header, Bottom, titleCom },
  data () {
    return {
      // 文物id
      culturalId: '',
      // 文物信息
      culturalInfo: {},
      imgList: [],
      imgNumber: 0,
      nextLength: 0,
      // 热点文物list
      rdwwList: [],
      pageNo: 1,
      pageSize: 5,
      total: 0,
      // 学术研究List
      academicList: []
    }
  },
  // 创建元素
  mounted () {
    this.culturalId = this.$route.query.id
    // 获取文物信息
    this.getOneById()
    // 获取热点文物
    this.getRdCultural()
    // 获取学术研究
    this.getAcademic()
  },
  // 方法定义
  methods: {

    // 点击前往首页
    goHome () {
      this.$router.push('/home')
    },

    // 点击前往精品文物
    goCultura () {
      this.$router.push('/cultural')
    },

    // 获取文物信息
    getOneById () {
      const self = this
      axios.get('/yuhuamenhu/collect/getOneById', {
        params: {
          id: this.culturalId
        }
      }).then(json => {
        if (json.data.code === 200) {
          self.culturalInfo = json.data.data
          const imgList = []
          json.data.data.urls.forEach((item, index) => {
            // imgList[index] = window.location.origin + item
            imgList[index] = 'http://files.travel-yuhuatai.com:8003' + item
          })
          self.imgList = imgList
          self.imgNumber = 0
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击上一个
    prev () {
      if (this.imgNumber === 0) {
        return
      }
      this.imgNumber--
      if (this.nextLength > 0) {
        this.nextLength -= 95
        this.$refs.swiper.style.transform = `translateY(-${this.nextLength}px)`
      }
    },

    // 点击下一个
    next () {
      if (this.imgNumber === this.imgList.length - 1) {
        return
      }
      if (this.imgNumber < this.imgList.length - 3) {
        this.nextLength += 95
        this.$refs.swiper.style.transform = `translateY(-${this.nextLength}px)`
      }
      this.imgNumber++
    },

    // 获取热点文物
    getRdCultural () {
      const self = this
      axios.get('/yuhuamenhu/collect/getRD').then(json => {
        if (json.data.code === 200) {
          self.rdwwList = json.data.data
          self.rdwwList.forEach(item => {
            item.imgUrl = window.location.origin + item.url
          })
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getAcademic()
    },

    // 学术研究
    getAcademic () {
      const self = this
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        selectBy: this.culturalId
      }
      axios.post('/juanzonggg/essay/listSpecialByCollectionId', data).then(json => {
        if (json.data.code === 200) {
          json.data.content.rows.forEach(item => {
            item.open = false
          })
          self.academicList = json.data.content.rows
          self.total = json.data.content.totalRows
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 查看摘要
    clickView (item) {
      item.open = !item.open
    },

    // 热点文物点击前往详情
    goDetail (item) {
      // eslint-disable-next-line no-case-declarations
      const culturalDetail = this.$router.resolve({
        path: '/culturalDetail',
        query: {
          id: item.id
        }
      })
      window.open(culturalDetail.href, '_blank')
    },

    // 学术研究跳转
    enterDetail (param) {
      const yjztDetail = this.$router.resolve({
        path: '/yjztDetail',
        query: {
          name: param.name,
          from: param.from
        }
      })
      window.open(yjztDetail.href, '_blank')
    }
  }
}
